// Types
export type {
  AvatarPageConfig,
  AvatarInfo,
  AssetCredit,
  ConsentModalConfig,
  InputControlsConfig,
  ChatOverlayConfig,
} from './types/avatar-page-config';

export type { Message, Messages } from './types/message';

// Constants
export {
  DEFAULT_AVATAR_CONFIG,
  DEFAULT_AVATAR_UI_INFO,
  DEFAULT_GRADIENT,
} from './constants/default-avatar-config';

// Lib
export {
  deepMerge,
  mergeAvatarConfig,
  useOptimizedMessages,
  useOptimizedLoading,
} from './lib/config-utils';

// Model
export { useCustomAvatarPage } from './model/use-custom-avatar-page';
export { useAvatarLoadingManager } from './model/use-avatar-loading-manager';
export { useAgentDataLogger } from './model/use-agent-data-logger';
export { useVADSynchronizer } from './model/use-vad-synchronizer';
export { useMessageHandler } from './model/use-message-handler';

// UI
export { default as CustomAvatarPage } from './ui/custom-avatar-page';
